<template>
    <a class="spacing back"
       data-ga=""
       @click="$router.go(-1)"
       v-if="show">
        <b-icon-chevron-left />上一步
    </a>
</template>

<script>
export default {
    name: 'Back',
    props: {
        show: Boolean
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.back {
    color: #999999;
    cursor: pointer;
    text-decoration: underline;
}
</style>
